// extracted by css-extract-rspack-plugin
export default {"heading":"Heading4_heading__4kUq0"};